<template>
    <div
        class="tw-my-8"
    >
        <Heading title="Mit welchem Budget dürfen wir Deine Reiseplanung starten?" :size="3" />
        <info-snippet hasBackground>
            Für eine {{ travelData.duration }}-tägige Reise in {{ countryName }} empfehlen unsere lokalen Experten ein Budget von {{ advisedBudget.toLocaleString('de-DE') }}€ pro Person.
            Dein Budget kommt der lokalen Wirtschaft zugute und trägt zur Wertschöpfung vor Ort bei.
        </info-snippet>
        <vue-slider
            class="tw-mx-4 tw-mt-8"
            v-model="sliderValue"
            :lazy="true"
            :interval="100"
            :min="min"
            :max="max"
            :dot-size="25"
            :process-style="{ backgroundColor: '#979797' }"
            :dot-style="{ backgroundColor: '#E15D61', boxShadow: '0 0 0 0' }"
            :tooltip-style="{ backgroundColor: '#E15D61', borderColor: '#E15D61'}"
            :tooltip-formatter="value => value.toLocaleString('de-DE') + '€' + (value === max ? '+' : '')"
        />
        <div class="tw-mt-2">
            {{ sliderValue[0].toLocaleString('de-DE') }}€ - {{ sliderValue[1].toLocaleString('de-DE') }}€{{ sliderValue[1] === max ? '+' : '' }} pro Person ohne Flug
        </div>
    </div>
</template>

<script>
import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";
import { mapGetters } from "vuex";
import InfoSnippet from "./InfoSnippet.vue";

export default {
    name: "BudgetSelector",
    components: {
        InfoSnippet,
        VueSlider
    },
    data: () => ({
        sliderValue: [0, 100],
        min: 0,
        max: 100000,
        advisedBudget: 0,
    }),
    computed: {
        ...mapGetters({
            tour: 'tour/route',
            country: 'tour/country',
            travelData: 'tour/travelData',
        }),
        countryName() {
            return this.country?.title || this.tour.mainCountry.staticCountry.shortName;
        }
    },
    mounted() {
        if(this.$store.getters['tour/travelData'].budget) {
            this.sliderValue = this.$store.getters['tour/travelData'].budget;
        }
        this.updateBudgetValues();
    },
    watch: {
        sliderValue: function (val) {
            this.$store.commit('tour/setBudget', val);
        },
        "$store.state.tour.travelData.duration": {
            handler: function () {
                this.updateBudgetValues()
            },
            deep: true,
        },
        "$store.state.tour.travelData.month": {
            handler: function () {
                this.updateBudgetValues()
            },
            deep: true,
        },
        "$store.state.tour.travelData.groupSize": {
            handler: function () {
                this.updateBudgetValues()
            },
            deep: true,
        },
    },
    methods: {
        updateBudgetValues() {
            const monthsShort = [
                "Jan", "Feb", "Mar", "Apr", "May", "Jun",
                "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"
            ];
            if (!this.travelData) {
                return;
            }
            const duration = this.travelData.duration;
            const countryData = this.country?.mainCountry || this.tour?.mainCountry;
            let budgetPerDay, minimumBudgetPerDay;

            // if tour has budget values, use them otherwise use the country values
            if(this.tour?.routeAdvisedBudgetPerDay && this.tour?.routeMinimumBudgetPerDay) {
                budgetPerDay = this.tour.routeAdvisedBudgetPerDay;
                minimumBudgetPerDay = this.tour.routeMinimumBudgetPerDay;
            } else {
                const selectedMonth = monthsShort[this.travelData.month - 1];

                if (selectedMonth && countryData.advisedBudgetPerDay[selectedMonth]) {
                    budgetPerDay = countryData.advisedBudgetPerDay[selectedMonth];
                    minimumBudgetPerDay = countryData.minimumBudgetPerDay[selectedMonth];
                } else {
                    budgetPerDay = countryData.advisedBudgetPerDay.default;
                    minimumBudgetPerDay = countryData.minimumBudgetPerDay.default;
                }
            }

            // add soloTravelerFactor
            if(this.travelData.groupSize.adults + this.travelData.groupSize.children + this.travelData.groupSize.infants === 1) {
                budgetPerDay *= (countryData.travelingAloneFactor || 1);
                minimumBudgetPerDay *= (countryData.travelingAloneFactor || 1);
            }

            const newValues = {
                min: Math.ceil(minimumBudgetPerDay * duration / 100) * 100,
                max: Math.ceil(budgetPerDay * duration * 2 / 100) * 100,
                advisedBudget: Math.ceil(budgetPerDay * duration / 100) * 100,
            };

            const defaultLower = Math.ceil(budgetPerDay * duration / 100) * 100;
            const defaultUpper = Math.ceil(budgetPerDay * duration * 1.2 / 100) * 100;


            if (
                this.sliderValue[0] === 0 && this.sliderValue[1] === 100 ||
                this.sliderValue[0] < newValues.min ||
                this.sliderValue[1] > newValues.max
            ) {
                newValues.sliderValue = [defaultLower, defaultUpper];
            } else {
                newValues.sliderValue = [...this.sliderValue];
            }

            // Update all values simultaneously
            Object.assign(this, newValues);
        }
    }
}
</script>